var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideos({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m17.652 3.7577h-11.304c-2.4 0-4.3478 1.9435-4.3478 4.3381v7.8085c0 2.3947 1.9478 4.3381 4.3478 4.3381h11.304c2.4 0 4.3478-1.9434 4.3478-4.3381v-7.8085c0-2.3946-1.9478-4.3381-4.3478-4.3381zm-3.1131 9.1534-3.3391 2.0042c-0.13912 0.07801-0.29564 0.12148-0.46087 0.12148-0.50434 0-0.91303-0.4251-0.91303-0.95447v-4.1558c0-0.52924 0.4087-0.96305 0.91303-0.96305 0.16523 0 0.32175 0.043377 0.46087 0.13014l3.3391 2.0042c0.31307 0.1822 0.5044 0.52924 0.5044 0.90232 0 0.38175-0.19133 0.72876-0.5044 0.91104z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideos);
export default __webpack_public_path__ + "static/media/videos.ce0c5e5fe701c0ea02e9721080b15485.svg";
export { ForwardRef as ReactComponent };